import validate from "/builds/common/airbaltic-com/bt-frontend-nuxt/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45root_45redirect_45global from "/builds/common/airbaltic-com/bt-frontend-nuxt/middleware/01.rootRedirect.global.ts";
import _02_45is_45valid_45sb_45url_45global from "/builds/common/airbaltic-com/bt-frontend-nuxt/middleware/02.isValidSBUrl.global.ts";
import _03_45login_45state_45global from "/builds/common/airbaltic-com/bt-frontend-nuxt/middleware/03.loginState.global.ts";
import manifest_45route_45rule from "/builds/common/airbaltic-com/bt-frontend-nuxt/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45root_45redirect_45global,
  _02_45is_45valid_45sb_45url_45global,
  _03_45login_45state_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}